// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"e1bfbe8c","455":"120c30fa","860":"f516b045"}[chunkId] + ".chunk.js";
};